import { createI18n } from 'vue-i18n'
import { messages } from './messages'
import { getStorageLanguage } from '@/utils/language.ts'

// Locales are auto-discovered from ./locales/*.json (see messages.ts); the
// canonical list + per-locale metadata lives in src/config/locales.json. To add
// a language you add its locale JSON + a registry entry — nothing changes here.
const i18n = createI18n({
    legacy: false,
    locale: getStorageLanguage(),
    fallbackLocale: 'en', // 备用语言
    messages
})

export default i18n
